import { render, staticRenderFns } from "./SimplifiedWord.vue?vue&type=template&id=1cd609ec&scoped=true&"
import script from "./SimplifiedWord.vue?vue&type=script&lang=js&"
export * from "./SimplifiedWord.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedWord.vue?vue&type=style&index=0&id=1cd609ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd609ec",
  null
  
)

export default component.exports